import React from 'react';
import { useSelector } from 'react-redux';
import { Menu } from 'antd';
import { Link } from 'react-router-dom';
import { buildMatchPath } from 'react-structure-admin';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useAuth from 'core/hooks/useAuth';
import { ROLE_ADMIN } from 'constants/types';

const HorizontalMenu = ({ routes, match, sub, readOnly }) => {
  const { pathname } = useSelector((state) => state.settings || {});

  const allowShow = (route) => {
    const { roles } = route;
    const { isAuthenticated, user, isAdmin } = useAuth();

    if (!isAuthenticated) {
      return false;
    }

    if (isAdmin()) {
      return true;
    }

    if (roles && !roles.some((c) => user.roles.includes(c) || c === '*')) {
      return false;
    }

    if (route?.hidden) {
      return !route.hidden(user?.settings);
    }

    return true;
  };

  const menu = (route, basePath, sub) => {
    let { roles } = route;
    const { hasRole } = useAuth();

    if (!Array.isArray(roles)) {
      roles = [];
    }

    if (
      route.routes &&
      route.isContainer !== false &&
      route.routes.find((c) => c.menu)
    ) {
      return (
        <Menu.SubMenu
          key={(basePath || '') + route.path}
          disabled={readOnly}
          title={
            <span>
              {route.title}
              <FontAwesomeIcon
                style={{ marginLeft: '5px' }}
                className="icon"
                icon="angle-down"
              />
            </span>
          }
        >
          {route.routes
            .filter((c) => c.menu)
            .map((c) => menu(c, route.path, true))}
        </Menu.SubMenu>
      );
    }

    if (roles.length > 0 && !hasRole(...roles, ROLE_ADMIN)) {
      return null;
    }

    return (
      <Menu.Item key={route.path} disabled={readOnly}>
        <Link to={`${buildMatchPath(match, (basePath || '') + route.path)}`}>
          {sub && route.menu && (
            <FontAwesomeIcon className="icon" icon={route.menu.icon} />
          )}
          <span>{route.title}</span>
        </Link>
      </Menu.Item>
    );
  };

  const defaultOpenKeys = pathname.replace('/app', '');

  return (
    <Menu defaultOpenKeys={[defaultOpenKeys]} mode="horizontal">
      {routes &&
        routes
          .filter(
            (route) =>
              allowShow(route) && (route.menu || route.isContainer === false)
          )
          .map((route) => menu(route))}
    </Menu>
  );
};

export default HorizontalMenu;
